import { onMounted, onUnmounted } from "vue";
import { useScreenStore } from "@/store/useScreenStore";

export function useScreenSize() {
    const screenStore = useScreenStore()

    onMounted(() => {
        screenStore.browserResized()
        window.addEventListener('resize', screenStore.browserResized)
    })

    onUnmounted(() => {
        window.removeEventListener('resize', screenStore.browserResized)
    })

    
}